import Marquee from "react-fast-marquee";
import { FadeUp } from "@/components/Reveal";
import { TRUST_INDICATORS } from "@/data/content";

const slug = (t) => t.toLowerCase().replace(/[^a-z]+/g, "-");

const MARQUEE_WORDS = [
  "Strategy",
  "Social Media",
  "SEO",
  "Google Ads",
  "Meta Ads",
  "Content Creation",
  "Web Design",
];

export function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/5 py-10"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {MARQUEE_WORDS.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-serif text-3xl italic text-cream/25 md:text-4xl">
              {w}
            </span>
            <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-gold/50" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-section"
      className="border-b border-white/5 py-20 lg:py-24"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <FadeUp className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-cream/50">
            Trusted by ambitious businesses across the UAE
          </p>
        </FadeUp>
        <div className="mt-14 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {TRUST_INDICATORS.map((t, i) => (
            <FadeUp key={t.title} delay={0.08 * i}>
              <div
                data-testid={`trust-indicator-${slug(t.title)}`}
                className="flex flex-col items-start"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-gold/30 bg-gold/5">
                  <t.icon className="h-5 w-5 text-gold" />
                </span>
                <h3 className="mt-5 font-serif text-xl text-cream">
                  {t.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-cream/50">
                  {t.description}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
